import {
    ADMINADDNEWBANK_SUCCESS,
    ADMINADDNEWBANK_FAILED,
    RESET_ADMINADDNEWBANK,
    LOADING_ADMINADDNEWBANK,
    NETWORK_ERROR_ADMINADDNEWBANK
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
    message: "",
    networkError: ""
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_ADMINADDNEWBANK:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
                message: "",
                networkError: ""
            };
        case ADMINADDNEWBANK_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case ADMINADDNEWBANK_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
                message: "",
                networkError: ""
            };
        case NETWORK_ERROR_ADMINADDNEWBANK:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
                message: "",
                networkError: ""
            };
        case RESET_ADMINADDNEWBANK:
            return (state = initialState);
        default:
            return state;
    }
};